export type UploadedFiles = {name: string}[] | null;
